/** Mirrors `CAPACITY_SLOT_DETAILS_MAX_LENGTH` on the server - the API rejects anything longer. */
export const SLOT_DETAILS_MAX_LENGTH = 250;

/**
 * Height ceiling for the `details` inputs. Shared so the add/update binder dialog and the
 * edit-section dialog cannot drift apart - the same field is edited from both.
 */
export const SLOT_DETAILS_MAX_ROWS = 4;
